import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "gamma",
    aws_cognito_region: "us-east-1",
    aws_cognito_identity_pool_id: "us-east-1:106b9a51-b55e-4f92-b5d6-77578221e858",
    aws_user_pools_id: "us-east-1_91U4HYzQt",
    aws_user_pools_web_client_id: "404eb9hqklmfboa88nkoe97gkf",
    Auth: {
      identityPoolId: "us-east-1:106b9a51-b55e-4f92-b5d6-77578221e858",
      region: "us-east-1",
      userPoolId: "us-east-1_91U4HYzQt",
      userPoolWebClientId: "404eb9hqklmfboa88nkoe97gkf",
    },
    oauth: {
      domain: `whs-navigator-gamma-na.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://gamma.na.navigator.whs.amazon.dev",
      redirectSignOut: "https://gamma.na.navigator.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
